import {
  secondary,
} from './constans';

export const menuView = {
  root: {
    backgroundColor: secondary,
  },
  mobileDrawer: {
    width: 260,
    opacity: '0.88',
  },
  desktopDrawer: {
    zIndex: 1300,
    width: '18%',
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  },
}
